import { useEffect } from "react";

interface PageHtmlRendererProps {
  html: string;
  page: { route?: string };
  path: string;
}

export function buildFormInterceptionScript(apiPath: string): string {
  const pathJson = JSON.stringify(apiPath);
  // Use \/ to avoid </script> in the script source
  return `
(function() {
  var path = ${pathJson};
  function init() {
    var forms = document.querySelectorAll("form[id]");
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      form.addEventListener("submit", function(e) {
        e.preventDefault();
        var f = e.target;
        var responses = [];
        var elements = f.querySelectorAll("input, select, textarea");
        for (var j = 0; j < elements.length; j++) {
          var el = elements[j];
          if (el.id && el.type !== "submit" && el.type !== "button") {
            var mapsTo = el.getAttribute("data-maps-to") || el.dataset.mapsTo;
            var resp = { htmlId: el.id, value: el.value || "" };
            if (mapsTo) resp.mapsTo = mapsTo;
            responses.push(resp);
          }
        }
        fetch("/api" + path, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ formHtmlId: f.id, responses: responses })
        })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.redirectUri) {
            window.location.href = data.redirectUri;
            return;
          }
          if (data.redirectTo) {
            window.location.href = data.redirectTo;
            return;
          }
        })
        .catch(function(err) { console.error("Form submit error:", err); });
      });
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
`.trim();
}

export function PageHtmlRenderer({ html, page, path }: PageHtmlRendererProps) {
  useEffect(() => {
    const apiPath = path || page?.route || "/";
    const script = buildFormInterceptionScript(apiPath);
    const scriptTag = `<script>${script}<\/script>`;
    const htmlWithScript = scriptTag + html;

    document.open();
    document.write(htmlWithScript);
    document.close();
  }, [html, page?.route, path]);

  return null;
}
